import { Div } from '@kizi/core-components';
import * as React from 'react';
import { EnergyLabel, EnergyProduct } from '../utils/product';
import { ModalAccordionProps, ModalAccordions } from './ModalAccordion';
import { Field, ProductProps } from './Product';
import { getEnergyLabelItemsList } from './Product/ExpandedPart/functions';
import { isMobile } from '../utils/global';

function getGasData(product: any, features: any[]): ModalAccordionProps {
  return {
    title: 'Gas',
    accordionInnerListVariant: 'accordionInnerList',
    fields: [
      {
        label: 'Product',
        value: product['name'],
      },
      {
        label: 'Contractduur',
        value: features[0].value,
      },
      {
        label: 'Tarieven',
        value: features[1].value,
      },
      {
        label: 'Soort gas',
        value: product['filters']['green'],
      },
      {
        label: 'Opzegtermijn',
        value: '1 maand',
      },
      {
        label: 'Minimaal verbruik',
        value: '0 m³',
      },
      {
        label: 'Maximaal verbruik',
        value: '10.000 m³',
      },
      {
        label: 'Aansluiting',
        value: '< 10 m³/h',
      },
    ],
  };
}

function getProductByType(products, type: 'electricity' | 'gas') {
  return products.find((product) => product.category === type);
}

function getEnergyLabelString(energy_label): string {
  const labels = getEnergyLabelItemsList(energy_label);

  let fullString = '';

  for (const item of labels) {
    fullString += `${item.value} ${item.label}, `;
  }

  fullString = fullString.substring(0, fullString.length - 2);

  return fullString;
}

function getElectricityData(
  energy_label: EnergyLabel | undefined,
  product: any,
  features: any[]
): ModalAccordionProps {
  let fields: Field[] = [
    {
      label: 'Product',
      value: product['name'],
    },
    {
      label: 'Contractduur',
      value: features[0].value,
    },
    {
      label: 'Tarieven',
      value: features[1].value,
    },
    {
      label: 'Soort stroom',
      value: product['filters']['green'],
    },
  ];

  const energyLabelString = getEnergyLabelString(energy_label);

  if (energyLabelString) {
    fields.push({
      label: 'Stroomherkomst',
      value: energyLabelString,
    });
  }

  fields = [
    ...fields,
    {
      label: 'Opzegtermijn',
      value: '1 maand',
    },
    {
      label: 'Minimaal verbruik',
      value: '0 kWh',
    },
    {
      label: 'Maximaal verbruik',
      value: '20.000 kWh',
    },
    {
      label: 'Aansluiting',
      value: '<= 3 * 25A',
    },
  ];

  return {
    title: 'Stroom',
    accordionInnerListVariant: 'accordionInnerList',
    fields,
  };
}

interface ProductDetailsProps
  extends Omit<ProductProps, 'data' | 'type' | 'nextIndex'> {
  data: EnergyProduct;
}

export const ProductDetails: React.FC<ProductDetailsProps> = React.forwardRef<
  HTMLDivElement,
  ProductDetailsProps
>(({ data, priceMode, ...restProps }: ProductDetailsProps, ref) => {
  const { energy_label, features, products } = data;

  let groups: ModalAccordionProps[] = [
    {
      mt: -15,
      title: 'Productinformatie',
      accordionInnerListVariant: 'accordionInnerList',
      fields: [
        {
          label: 'Loyaliteitsbonus',
          value: 'De bonus wordt verrekend zoals in de voorwaarden staat benoemd. Vaak is dit aan het einde van de contractduur.',
        },
      ],
    },
  ];

  const elProduct = getProductByType(products, 'electricity');
  const gasProduct = getProductByType(products, 'gas');

  if (elProduct) {
    groups.push(getElectricityData(energy_label, elProduct, features));
  }
  if (gasProduct) {
    groups.push(getGasData(gasProduct, features));
  }

  groups.push({
    title: 'Voorwaarden',
    accordionInnerListVariant: 'accordionInnerList',
    fields: [
      {
        label: 'Aangesloten bij Gedragscode Consument en Energieleverancier',
        icon: 'green-check',
      },
    ],
  });

  return (
    <Div {...restProps} ref={ref} variant="accordionContainer">
      <ModalAccordions groups={groups} allAreOpen={!isMobile()} />
    </Div>
  );
});
